module.exports = __webpack_public_path__ + "assets/img/component.d0738c40.svg";